export const waBroadCastMessageTemplates = [
  {
    id: 1,
    name: "Standalone Database Outreach Template",
    template: `Hi,
 
We came across your profile on Job Hai and think you could be a good fit for the following opportunity:
 
Job Details  
💼 Job Category: {{job_category}}
🏢 Company Name: {{company_name}}
📍 Location: {{address}}
 
If you're interested, simply reply 'Yes' and we'll connect with you to share next steps.  
You can also reach me directly at {{recruiter_phone}}.
 
Best Regards,  
{{recruiter_first_name}}
`
  }
];
